import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { Box, Button } from "@mui/material";
import PlusIcon from "@iconify/icons-mdi/plus";
import { InlineIcon } from "@iconify/react";
import { useMyHrUserRolesDataByContract } from "my-hr/hooks";
import { MyNewsAdminList, MyNewsList } from "my-news/components";
import { myNewsListFilterState } from "my-news/states/my-news-list-filter-state";
import { OcPageNameTitle, OcPageTransition } from "oc/components";
import {
  useOcButtonGroup,
  useOcCurrentUserState,
  useOcIsMobile,
} from "oc/hooks";

export const MyNewsListPage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [filter, setFilter] = useRecoilState(myNewsListFilterState);
  const isMobile = useOcIsMobile();

  let { contractCode } = useOcCurrentUserState();
  const { hasRole } = useMyHrUserRolesDataByContract({
    contract: contractCode,
  });
  let hasEditorRight = hasRole(["MyNews.editor"], []);

  const isUserList = filter === "current" || filter === "archived";
  const isArchived = filter === "archived";

  let buttonsDef = [];

  switch (true) {
    case hasEditorRight:
      buttonsDef = ["MY_NEWS_ACTUAL", "MY_NEWS_ARCHIVED", "MY_NEWS_OWN_NEWS"];
      break;
    default:
      buttonsDef = ["MY_NEWS_ACTUAL", "MY_NEWS_ARCHIVED"];
  }
  const { OcButtonGroup, selectedButton } = useOcButtonGroup({
    id: `MyNewsNewsListPage`,
    buttonsDef,
  });

  const handleChangeFilter = (filter: string) => {
    setFilter(filter);
  };

  const handleClickNew = () => {
    history.push("/my-news/new");
  };

  useEffect(() => {
    if (selectedButton === "MY_NEWS_ACTUAL") {
      handleChangeFilter("current");
    } else if (selectedButton === "MY_NEWS_ARCHIVED") {
      handleChangeFilter("archived");
    } else if (selectedButton === "MY_NEWS_OWN_NEWS") {
      handleChangeFilter("myNews");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedButton]);

  return (
    <OcPageTransition>
      <OcPageNameTitle title={t("MY_NEWS_NEWS")} goBack={false} />
      <Box padding={isMobile ? "0px 0px 16px 0px" : "0px 16px 16px 16px"}>
        <Box
          padding={isMobile ? "0px 16px 16px 16px" : "6px 0px 22px 0px"}
          display="flex"
          flexDirection={isMobile ? "column-reverse" : "row"}
          justifyContent="space-between"
        >
          <Box width={isMobile ? "0px" : "140px"} />
          <OcButtonGroup />
          {isMobile && <Box height="16px" />}
          <Box
            width={isMobile ? "auto" : "140px"}
            display="flex"
            justifyContent="flex-end"
          >
            {hasEditorRight && (
              <Button
                id="new-my-news-item"
                variant="contained"
                color="primary"
                disableElevation
                onClick={handleClickNew}
                startIcon={<InlineIcon icon={PlusIcon} />}
              >
                {t("MY_NEWS_NEW_ITEM")}
              </Button>
            )}
          </Box>
        </Box>
        {isUserList ? (
          <MyNewsList archived={isArchived} isMobile={isMobile} />
        ) : (
          <MyNewsAdminList isMobile={isMobile} />
        )}
      </Box>
    </OcPageTransition>
  );
};

export default MyNewsListPage;
